import api from '../../../services/api';

export const ReceiptsHTTP = {
  get: (params = {}) => api.get('/receipts', {params}),
};
